/**
 * Generated runtime TestId mirror for frontend/src/pages/MyResponsibilities.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const MyResponsibilitiesTabId = {
  AccessProfiles: "access-profiles",
  AutoAssignRules: "auto-assign-rules",
  CertificationCampaigns: "certification-campaigns",
  CertificationPolicies: "certification-policies",
  FunctionGroups: "function-groups",
  Resources: "resources",
  RestrictionRules: "restriction-rules",
  TargetSystems: "target-systems",
} as const;
export type MyResponsibilitiesTabId = typeof MyResponsibilitiesTabId[keyof typeof MyResponsibilitiesTabId];

export const MyResponsibilitiesTestIds = {
  myResponsibilitiesOuterTabs: "my-responsibilities-outer-tabs",
  tab: (subtype: MyResponsibilitiesTabId) => `tab-${subtype}` as const,
  tabPrefix: () => "tab-" as TestIdPrefix
} as const;
